export enum DepositSource {
	GameFrame = "GameFrame",
	Normal = "Normal",
	QuickDeposit = "QuickDeposit",
}
